import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { SkillService } from '../services/skill.service';
import { ActivatedRoute } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {
  public displayData;
  id: number;
  private sub: any;

  constructor(public skillService: SkillService,
    private location: Location,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['id'];
    });
    this.displayData = this.skillService.userDetail;
  }

  locationBack() {
    this.location.back();
  }
  trackByFn(index) {
    return index;
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/skill-matrix/user-detail/user-detail.component.ts